var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"🖥️-Desktop","stroke":"inherit","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinejoin":"bevel"},React.createElement("g",{"id":"6.3-Solutions->-Construction","transform":"translate(-155.000000, -3794.000000)","strokeWidth":"2"},React.createElement("g",{"id":"arrow-left","transform":"translate(156.000000, 3795.000000)"},[React.createElement("line",{"x1":"44","y1":"18.6090535","x2":"0","y2":"18.6090535","id":"Path","key":0}),React.createElement("polyline",{"id":"Path","points":"18.7234043 38 1.3858103e-15 18.6090535 18.7234043 0","key":1})]))));
}

ArrowLeft.defaultProps = {"width":"45px","height":"40px","viewBox":"0 0 45 40","version":"1.1"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
